export const glassStyle = {
  base: "backdrop-filter backdrop-blur-lg bg-white/80 border border-gray-200 shadow-xl",
  card: "backdrop-filter backdrop-blur-lg bg-white/80 border border-gray-200 shadow-xl rounded-2xl p-6",
  input: "backdrop-filter backdrop-blur-lg bg-white/80 border border-gray-200 shadow-xl pl-10 w-full rounded-lg py-3 px-4 text-gray-900 focus:border-[#468BFF]/50 focus:outline-none focus:ring-1 focus:ring-[#468BFF]/50 placeholder-gray-400 bg-white/80 shadow-none"
};

export const fadeInAnimation = {
  fadeIn: "transition-all duration-300 ease-in-out",
  writing: "animate-pulse"
}; 